import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../../utils/seo';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ReasonsSection from './components/ReasonsSection';
import ServiceSection from './components/ServiceSection';
import RecruitCTA from './components/RecruitCTA';
import AccessSection from './components/AccessSection';

export default function HomePage() {
  useSEO({
    title: '逗子市訪問介護まごころヘルパー | 信頼の介護サービス',
    description: '逗子市で訪問介護サービスをお探しなら、まごころヘルパーへ。経験豊富なスタッフが身体介護・生活援助・服薬確認など、ご利用者様の日常生活を心を込めてサポートします。JR東逗子駅徒歩7分、京急逗子葉山駅徒歩2分。無資格・未経験者も歓迎。訪問介護のプロフェッショナルとして、地域の皆様の安心な暮らしをお手伝いします。',
    keywords: '訪問介護,介護サービス,逗子市,まごころヘルパー,身体介護,生活援助,ヘルパー募集',
    path: '/',
    schema: {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "まごころヘルパー",
      "image": "https://public.readdy.ai/ai/img_res/cecac1c78f8f76d13dcb37656d062687.jpg",
      "description": "逗子市で信頼できる訪問介護サービスを提供するまごころヘルパー。身体介護・生活援助・服薬確認など、ご利用者様の日常生活を心を込めてサポートします。",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "逗子5-7-17 コーポ高木101",
        "addressLocality": "逗子市",
        "addressRegion": "神奈川県",
        "postalCode": "249-0006",
        "addressCountry": "JP"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "35.2947",
        "longitude": "139.5808"
      },
      "telephone": "+81-46-876-6471",
      "openingHoursSpecification": [
        {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
          "opens": "09:00",
          "closes": "18:00"
        }
      ],
      "url": `${import.meta.env.VITE_SITE_URL}/`,
      "priceRange": "¥¥",
      "areaServed": {
        "@type": "City",
        "name": "逗子市"
      }
    }
  });

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in-up');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.observe-animation').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <AboutSection />
      <ReasonsSection />
      <ServiceSection />
      <RecruitCTA />
      <AccessSection />
    </div>
  );
}
